import React, {Component} from 'react';

//Resources
import {Image, Row, Col} from 'react-bootstrap';
import {BrowserRouter as Link } from "react-router-dom";
import logoSiman from '../../Resources/Images/LogoSiman.png';
import configs from '../../Config.json';

//Components
import SeleccionPaises from './SeleccionPaises';

class Header extends Component {

    constructor(props) {
        super(props)
        this.state = {
            searching: false,
            busqueda: '',
            fullEventos: [],
            fullEventosOriginal: this.props.fullEventosOriginal
        }

    }
 
    render() {
        const { varPais } = this.props;
        const { keyTok } = this.props;

        return(
            <Row lg={1} className="d-flex justify-content-center bg-siman sticky-top p-3 clubes--row clubes--header-row">
                <Col>
                <div>
                    <div className="clubes-row">
                {/** Flag del pais */}
                <div className="container">
                <Row lg={2}>
                    <Col className="clubes--nav-item clubes--nav-item-logo d-flex justify-content-md-start">
                        { (varPais === configs[0].paisSV) ? <Link to={varPais} >
                        <Image src={logoSiman} fluid/> </Link>
                        :null   
                        }
                        { (varPais === configs[0].paisGT) ? <Link to={varPais}>
                        <Image src={logoSiman} fluid/>   </Link>
                        :null   
                        }
                        { (varPais === configs[0].paisCR) ? <Link to={varPais}>
                        <Image src={logoSiman} fluid/>   </Link>
                        :null   
                        }
                        { (varPais === configs[0].paisNI) ? <Link to={varPais} >
                        <Image src={logoSiman} fluid/>   </Link>
                        :null   
                        }
                    </Col>
                    <SeleccionPaises varPais={varPais} keyTok={keyTok}></SeleccionPaises>
                    
                </Row>
                </div>
                </div>
                </div>
                </Col>
            </Row>
        );
    }

}

export default Header;